import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../useI18n.js';
import { DRAW_W, DRAW_H, getCanvas, copyDrawingToClipboard } from '../drawStore';

function EndDrawing({ t }) {
  const ref = useRef(null);
  const [copied, setCopied] = useState('');
  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    c.getContext('2d').drawImage(getCanvas(), 0, 0);
  }, []);
  const doCopy = async () => {
    try { await copyDrawingToClipboard(); setCopied('ok'); } catch { setCopied('err'); }
    setTimeout(() => setCopied(''), 1500);
  };
  return (
    <div className="end-drawing">
      <h3>{t('drawTitle') || 'Le chef-d’œuvre collectif'}</h3>
      <canvas ref={ref} width={DRAW_W} height={DRAW_H} className="end-drawing-canvas" />
      <button type="button" className="draw-export" onClick={doCopy}>
        {copied === 'ok' ? (t('drawCopied') || 'Copie !') : copied === 'err' ? (t('drawCopyErr') || 'Echec') : (t('drawExport') || 'Exporter')}
      </button>
    </div>
  );
}

export function GameEndOverlay({ visible, ranking, eloChanges, isChef, onRestart, onQuit, showDrawing }) {
  const { t } = useI18n();
  if (!visible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{t('gameEnded')}</h2>
        {showDrawing && <EndDrawing t={t} />}
        <h3>{t('finalRanking')}</h3>
        <ol style={{ textAlign: 'left' }}>
          {ranking.map(r => {
            const change = eloChanges && eloChanges[r.pseudo];
            return (
              <li key={r.pseudo}>
                {r.pseudo}: {r.score}
                {change && (
                  <span style={{ marginLeft: 8, fontWeight: 700, color: change.delta >= 0 ? '#16a34a' : '#dc2626' }}>
                    {change.delta >= 0 ? '+' : ''}{change.delta} ELO
                    {typeof change.elo === 'number' && <span style={{ opacity: 0.7, fontWeight: 400 }}> ({change.elo})</span>}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
        <div style={{ marginTop: '1rem' }}>
          {isChef && <button onClick={onRestart}>{t('restart')}</button>}
          <button onClick={onQuit}>{t('quit')}</button>
        </div>
      </div>
    </div>
  );
}
